// CRM backend stores naive UTC datetimes (datetime.utcnow) as ISO without offset.
// Always interpret them as UTC and render in Kazakhstan business timezone.

export const CRM_TIMEZONE = "Asia/Almaty";

const HAS_TIMEZONE = /[zZ]|[+-]\d{2}:\d{2}$/;

export function parseCrmDateTime(value) {
  if (!value) return null;
  const raw = String(value).trim();
  if (!raw) return null;

  const normalized = HAS_TIMEZONE.test(raw) ? raw : `${raw}Z`;
  const dt = new Date(normalized);
  return Number.isNaN(dt.getTime()) ? null : dt;
}

export function formatCrmDateTime(value, options = {}) {
  const dt = parseCrmDateTime(value);
  if (!dt) return "—";
  return dt.toLocaleString("ru-RU", {
    timeZone: CRM_TIMEZONE,
    dateStyle: "short",
    timeStyle: "short",
    ...options,
  });
}

export function formatCrmDate(value, options = {}) {
  const dt = parseCrmDateTime(value);
  if (!dt) return "—";
  return dt.toLocaleDateString("ru-RU", {
    timeZone: CRM_TIMEZONE,
    dateStyle: "medium",
    ...options,
  });
}
